import styled from "styled-components"
import { AlertCircle } from "react-feather"

export const StyledCrossValidation = styled(AlertCircle)`
  color: #ee6160;
  min-height: 16px;
  min-width: 16px;
  height: 16px;
  width: 16px;
  margin: 0 1.6rem 0 0;
  pointer-events: none;
  @media (max-width: 1024px) {
    margin: 0 1.3rem 0 0;
  }
`
